export default function getDataFromQRCode(data: string) {
    const dataArray = data.split(",");

    const setValue = (value: string) => {
        return value !== "notSpecified" ?  value : "";
    }

    let isTest = false;
    let firstName, lastName, submittedOn, authority, encryptedSignature;
    firstName = setValue(dataArray[0]);
    lastName = setValue(dataArray[1]);
    submittedOn = setValue(dataArray[2]);
    authority = setValue(dataArray[3]);
    if(dataArray[dataArray.length-1] !== "notSpecified") {
        isTest = parseInt(dataArray[dataArray.length-1].split(".")[1])  === 0;
        encryptedSignature = dataArray[dataArray.length-1].split(".")[0];
    }
    const rawData = firstName + " " + lastName + " " + submittedOn;
    return {
        rawData,
        firstName,
        lastName,
        submittedOn,
        authority,
        encryptedSignature,
        isTest
    };
}
